import { ApiTableColumn, FetchProps } from '@e3dc-react/shell/Elements/ApiView/ApiView'
import { UseFetchProps } from '@e3dc-react/shell/Hooks/useFetch'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { format } from 'date-fns'

import { ErrorLogDto } from '../dto/error-logs.dto'

/**
 * This hook holds all data for the error logs api view
 */
export const useErrorLogsTableData = (
  serialNo: string
): {
  fetchProps: UseFetchProps
  columns: ApiTableColumn<ErrorLogDto>[]
} => {
  const { t } = useCustomTranslation()

  const fetchProps: FetchProps = {
    url: `error-logs/${serialNo}`,
    orderBy: '-id',
    endpoint: process.env.REACT_APP_ERROR_LOGS_ENDPOINT,
  }

  const emptySymbol = '-'

  const columns: ApiTableColumn<ErrorLogDto>[] = [
    {
      name: 'id',
      label: t('system-details.error-logs.table.id'),
      value: ({ id }) => id ?? emptySymbol,
    },
    {
      name: 'errorType',
      label: t('system-details.error-logs.table.error-type'),
      value: ({ errorType }) => t('system-details.error-logs.table.types.' + errorType, { defaultValue: errorType ?? emptySymbol }),
    },
    {
      name: 'source',
      label: t('system-details.error-logs.table.source'),
      value: ({ source }) => source ?? emptySymbol,
    },
    {
      name: 'code',
      label: t('system-details.error-logs.table.code'),
      value: ({ code }) => code ?? emptySymbol,
    },
    {
      name: 'message',
      label: t('system-details.error-logs.table.message'),
      value: ({ message }) => message ?? emptySymbol,
    },
    {
      name: 'occurCount',
      label: t('system-details.error-logs.table.occur-count'),
      value: ({ occurCount }) => occurCount ?? emptySymbol,
    },
    {
      name: 'firstOccur',
      label: t('system-details.error-logs.table.first-occur'),
      value: ({ firstOccur }) => (firstOccur ? format(new Date(firstOccur), t('system-details.error-logs.table.date-format')) : emptySymbol),
    },
    {
      name: 'lastOccur',
      label: t('system-details.error-logs.table.last-occur'),
      value: ({ lastOccur }) => (lastOccur ? format(new Date(lastOccur), t('system-details.error-logs.table.date-format')) : emptySymbol),
    },
    {
      name: 'cleared',
      label: t('system-details.error-logs.table.cleared'),
      value: ({ cleared }) => (cleared ? format(new Date(cleared), t('system-details.error-logs.table.date-format')) : emptySymbol),
    },
  ]

  return { columns, fetchProps }
}
